

















import { defineComponent } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-placement-block-list-switch-tips';

export default defineComponent({
  name,
  components: {
    ALink,
  },
  setup() {
    function onLinkClick() {
      trackEvent('create_adgroup_placement_pangle_block_list_learn_more_click');
    }
    return {
      name,
      onLinkClick,
    };
  },
});
